<template>
  <div class="dante-about" :class="[$tvaMq]">
    <div class="dante-about__container">
      <Menu />
      <div class="dante-about__project">
        <div class="dante-about__project__goback">
          <div class="go-back button--tertiary" @click="goBack()">
            <svgicon
              class="icon-arrow-left"
              icon="icon-arrow-left"
              width="12"
              height="12"
            ></svgicon
            >{{ content.btnExit }}
          </div>
        </div>
        <h1 class="dante-about__project__title">{{ content.title }}</h1>
        <p
          class="dante-about__project__paragraph"
          v-for="(par, i) in content.paragraphs"
          v-html="par"
          :key="i"
        ></p>
      </div>
      <div class="dante-about__tva">
        <div class="dante-about__credits">
          <div class="dante-about__credits__credit">
            <div class="dante-about__tva__label" v-html="content.project"></div>
            <a href="https://thevisualagency.com/" target="_blank">
              <img
                class="dante-about__tva__logo"
                alt="The Visual Agency"
                :src="`${baseUrl}images/logo/logo_tva.svg`"
                :style="{ width: '110px', maxWidth: 'none' }"
              />
            </a>
          </div>
          <div class="dante-about__credits__credit">
            <div class="dante-about__tva__label" v-html="content.sponsor"></div>
            <a href="https://ladante.it/" target="_blank">
              <img
                class="dante-about__tva__logo"
                alt="Società Dante Alighieri"
                :src="`${baseUrl}images/logo/logo_ladante.svg`"
              />
            </a>
          </div>
        </div>
        <div class="dante-about__tva__label">{{ content.team }}</div>
        <div class="dante-about__tva__list">{{ content.teamMembersList }}</div>
        <div class="dante-about__tva__label">{{ content.greetings }}</div>
        <div
          class="dante-about__tva__list"
          v-html="content.greetingsList"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from "@/components/Menu";
import "@/compiled-icons/icon-arrow-left";
export default {
  computed: {
    content() {
      return this.$ml.get("about");
    }
  },
  methods: {
    goBack() {
      const lastRoutePath = localStorage.getItem("LS_ROUTE_KEY");
      this.$router.push({
        path: lastRoutePath
      });
    }
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  components: {
    Menu
  }
};
</script>
<style lang="scss">
.dante-about {
  background-color: $black;
  color: $white;

  .tablet & {
    height: 100vh;
    width: 100vw;
    padding: 40px 100px 80px;
    overflow-y: auto;
  }
  .desktop & {
    flex-direction: row;
    height: 100vh;
    width: 100vw;
    padding: 0 10vw;
    .dante-about__container {
      height: calc(100%);
      display: flex;
    }
  }
  &__project {
    .mobile & {
      padding: 50px 16px;
    }
    .desktop & {
      //padding-left: 120px;
      max-width: 70%;
      padding: 5vw 0;
      padding-right: 50px;
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: auto;
      &__goback {
        background: #000;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 5vw;
      }
    }
    .go-back {
      position: absolute;
      top: $margin-M;
      left: 10vw;
      .mobile & {
        left: 16px;
      }
      .icon-arrow-left {
        margin-right: 10px;
      }
    }
    &__title {
      @include HH1;
      .mobile & {
        @include HH3;
      }
      // .desktop & {
      //   margin: 0;
      // }
    }
    &__paragraph {
      @include pM;
      .mobile & {
        @include pM;
      }
      .desktop & {
        padding-top: 20px;
        max-width: 80%;
      }

      &:last-of-type {
        .tablet & {
          padding-bottom: $margin-M;
          padding-top: 40px;
          a {
            color: $white;
          }
        }
      }
    }
  }

  &__project,
  &__tva {
    &::-webkit-scrollbar {
      width: 0.3em;
      height: 0.3em;
    }

    &::-webkit-scrollbar-thumb {
      background: $white-50;
      border-radius: 40px;
    }

    &::-webkit-scrollbar-track {
      background: $black-10;
      border-radius: 40px;
      border: none;
    }
  }

  &__tva {
    border-top: 1px solid $white-50;
    @include pXS;
    .mobile & {
      padding: 50px 16px;
    }

    .desktop & {
      padding: 5vw 0;
      height: 100%;
      overflow: auto;
      max-width: 30%;

      border-left: 1px solid $white-50;
      border-top: none;
      padding-left: 50px;
    }
    &__label {
      @include overlayS;
      text-transform: uppercase;
      margin-bottom: 12px;
      &:nth-of-type(4) {
        margin-top: 30px;
      }

      .tablet & {
        margin-top: $margin-S;
      }
    }
    &__logo {
      max-width: 100px;
      margin-bottom: 20px;

      .tablet & {
        margin-bottom: $margin-XS;
      }
    }
  }

  a {
    color: $white !important;
    text-decoration: underline;
    &:visited {
      color: $white !important;
    }
  }
}
</style>
